module.exports = __webpack_public_path__ + "assets/images/04-balloon_81e04db94c824eaf6580409ebb77b3c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/04-balloon.png
// module id = 175
// module chunks = 0